<template>
  <v-container v-if="personal">
    <v-row justify="center">
      <v-col cols="12">
        <v-row>
          <v-col cols="2">
            <v-btn text @click="$router.go(-1)">
              <v-icon>mdi-arrow-left</v-icon>
              Volver
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="5">
        <v-card class="ui-module-card ui-module-fade-in-up">
          <v-card-title class="ui-module-titlebar font-weight-bold justify-center"
            >Asignación de puesto, función y adscripción</v-card-title
          >
          <v-card-text>
            <v-container class="mb-4">
              <v-row align="center">
                <v-col cols="4" align="center">
                  <v-progress-circular
                    :value="activeStep * 25"
                    color="secondary"
                    v-bind="circularProgressProps"
                  ></v-progress-circular>
                </v-col>
                <v-col cols="8">
                  <div class="text-caption step-label">PASO {{ activeStep }}</div>
                  <div class="text-subtitle-1 font-weight-bold step-title">{{ activeStepTitle }}</div>
                  <a class="text-decoration-none back-link" v-show="activeStep != 1" v-on:click="activeStep--"
                    >Volver al paso anterior</a
                  >
                </v-col>
              </v-row>
            </v-container>
            <v-container v-if="activeStep == 1">
              <v-form>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      :value="getFullName(personal)"
                      rounded
                      filled
                      dense
                      label="Nombre del personal"
                      maxlength="20"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" v-if="personal.CatRamaDependencia">
                    <v-text-field
                      rounded
                      filled
                      dense
                      label="Dependencia actual"
                      :value="personal.CatRamaDependencia.CatDependencia.nombre"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete
                      v-model="personal.fk_idRamaDependencia"
                      rounded
                      filled
                      dense
                      :items="ramas"
                      item-value="id"
                      item-text="ramaDependencia"
                      :rules="nameRules"
                    >
                      <template v-slot:label>Dirección <span class="required-asterisk">*</span> </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete
                      v-model="personal.fk_idCatArea"
                      rounded
                      filled
                      dense
                      :items="filteredAreas"
                      item-value="id"
                      item-text="nombre"
                      :rules="nameRules"
                    >
                      <template v-slot:label>Adscripción <span class="required-asterisk">*</span> </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete
                      v-model="personal.fk_idCatSubArea"
                      label="Subárea"
                      rounded
                      filled
                      dense
                      :items="filteredSubareas"
                      item-value="id"
                      item-text="nombre"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
            <v-container v-if="activeStep == 2">
              <v-form>
                <v-row>
                  <v-col cols="12">
                    <v-autocomplete
                      v-model="personal.fk_idPuestoDependencia"
                      rounded
                      filled
                      dense
                      :items="puestos"
                      item-value="id"
                      item-text="catPuesto.puesto"
                      :rules="nameRules"
                    >
                      <template v-slot:label>Puesto <span class="required-asterisk">*</span> </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <div class="text-subtitle-2 radio-label">
                      Tipo de puesto <span class="required-asterisk">*</span>
                    </div>
                    <v-radio-group v-model="personal.fk_idCatTipoFuncion">
                      <v-radio
                        v-for="tipo in tipoFuncion"
                        :key="tipo.id"
                        :label="tipo.title"
                        :value="tipo.id"
                        color="secondary"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
            <v-container v-if="activeStep == 3">
              <v-form>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="personal.plaza"
                      rounded
                      filled
                      dense
                      label="Plaza"
                      maxlength="20"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
            <v-container v-if="activeStep == 4">
              <v-form>
                <v-row>
                  <v-col cols="12">
                    <v-autocomplete
                      v-model="selectedSede"
                      rounded
                      filled
                      dense
                      :items="sedes"
                      item-value="id"
                      item-text="sede"
                      :rules="nameRules"
                      @change="onSedeChange"
                    >
                      <template v-slot:label>Sede <span class="required-asterisk">*</span></template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete
                      v-model="personal.fk_idSubsede"
                      rounded
                      filled
                      dense
                      :items="subsedesFiltradas"
                      item-value="id"
                      item-text="nombre"
                      :rules="nameRules"
                      :disabled="!selectedSede"
                      :hint="!selectedSede ? 'Selecciona primero una sede' : ''"
                      persistent-hint
                    >
                      <template v-slot:label>Subsede <span class="required-asterisk">*</span></template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
            <v-container>
              <v-row>
                <v-col md="12" xl="6" offset-xl="3">
                  <v-btn
                    block
                    color="secondary"
                    v-on:click="activeStepButtonHandler"
                    :loading="loading"
                    :disabled="!validActiveStep || loading"
                    >{{ activeStepButtonLabel }}</v-btn
                  >
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { circularProgressProps } from '../../components/props/props'
import Notificacion from '@/modules/notificaciones/domain/Notificacion'
import { NotificationFactory, NOTIFICATION_TYPES } from '@/modules/notificaciones/domain/NotificationFactory'

export default {
  props: {
    id: {
      type: Number,
    },
  },

  async mounted() {
    await this.fetchPersonalById(this.id)
    await this.fetchTipoPuesto()
    await this.fetchTipoFuncion()
    await this.fetchSedes()
    await this.fetchSubsedes()
    if (this.personal && this.personal.fk_idCatTipoFuncion !== undefined) {
      this.prevTipoFuncionId = this.personal.fk_idCatTipoFuncion
    }
  },

  data() {
    return {
      circularProgressProps,
      activeStep: 1,
      loading: false,
      asignaSedePersonalForm: false,
      dependencia: null,
      rama: null,
      region: null,
      selectedSede: null,
      subsedesFiltradas: [],
      nameRules: [(v) => !!v || 'Este campo es requerido.'],
      prevTipoFuncionId: null,
    }
  },

  watch: {
    personal: {
      immediate: true,
      handler(newVal) {
        if (!newVal) return
        if (newVal.fk_idSubsede && this.subsedes.length > 0) {
          const subsede = this.subsedes.find((s) => s.id === newVal.fk_idSubsede)
          if (subsede?.fk_idSede) {
            this.selectedSede = subsede.fk_idSede
            this.loadSubsedesBySede(subsede.fk_idSede)
          }
        }
      },
    },
    subsedes: {
      immediate: true,
      handler(newVal) {
        if (!newVal?.length || this.selectedSede || !this.personal?.fk_idSubsede) return
        const subsede = newVal.find((s) => s.id === this.personal.fk_idSubsede)
        if (subsede?.fk_idSede) {
          this.selectedSede = subsede.fk_idSede
          this.loadSubsedesBySede(subsede.fk_idSede)
        }
      },
    },
  },

  computed: {
    ...mapGetters('dependencia', { dependencias: 'getDependencias' }),
    ...mapGetters('rama', { ramas: 'getRamas' }),
    ...mapGetters('puesto', { puestos: 'getPuestos' }),
    ...mapGetters('tipoPuesto', { tipoPuesto: 'getTipoPuesto' }),
    ...mapGetters('tipoFuncion', { tipoFuncion: 'getTipoFuncion' }),
    ...mapGetters('personal', { personal: 'getPersonalSingle' }),
    ...mapGetters('areas', { areas: 'getAreas' }),
    ...mapGetters('subareas', { subareas: 'getSubareas' }),
    ...mapGetters('sede', { sedes: 'getSedes' }),
    ...mapGetters('subsede', { subsedes: 'getSubsedes' }),

    activeStepTitle() {
      switch (this.activeStep) {
        case 1:
          return 'Dirección, adscripción y área'
        case 2:
          return 'Puesto'
        case 3:
          return 'Plaza'
        case 4:
          return 'Pase de lista'
        default:
          return ''
      }
    },

    validActiveStep() {
      if (this.activeStep === 4) {
        return !!this.selectedSede && !!this.personal.fk_idSubsede
      }
      return true
    },

    activeStepButtonLabel() {
      return this.activeStep < 4 ? 'Siguiente paso' : 'Guardar registro'
    },

    filteredAreas() {
      return this.areas.filter((area) => area.fk_idCatRamaDependencia == this.personal.fk_idRamaDependencia)
    },

    filteredSubareas() {
      return this.subareas.filter((subarea) => subarea.fk_idCatArea == this.personal.fk_idCatArea)
    },

  },

  methods: {
    ...mapActions('personal', [
      'updatePuestoPersonal',
      'updateAreaPersonal',
      'fetchPersonal',
      'updatePersonal',
      'updateSubareaPersonal',
      'fetchPersonalById',
    ]),
    ...mapMutations('personal', ['SET_PERSONAL_FOTO_CUIP']),
    ...mapActions('tipoPuesto', ['fetchTipoPuesto']),
    ...mapActions('tipoFuncion', ['fetchTipoFuncion']),
    ...mapActions('puesto', ['fetchPuestosByDependencia']),
    ...mapActions('sede', ['fetchSedes']),
    ...mapActions('subsede', ['fetchSubsedes', 'fetchSubsedesBySede']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapActions('notificaciones', ['createNotification', 'fetchNotifications']),

    getFullName(persona) {
      if (!persona) return ''
      return [persona.nombre, persona.segundoNombre, persona.apaterno, persona.amaterno].filter(Boolean).join(' ')
    },

    async activeStepButtonHandler() {
      if (this.activeStep < 4) {
        if (this.activeStep === 1) {
          this.prevTipoFuncionId = this.personal.fk_idCatTipoFuncion
        }
        this.activeStep++
      } else {
        this.loading = true

        await this.updatePersonal(this.personal)
        await this.updatePuestoPersonal({
          idPersonal: this.id,
          fk_idPuestoDependencia: this.personal.fk_idPuestoDependencia,
        })
        await this.updateAreaPersonal({
          idPersonal: this.id,
          fk_idCatArea: this.personal.fk_idCatArea,
        })

        if (this.personal.fk_idCatSubArea != 0) {
          await this.updateSubareaPersonal({
            idPersonal: this.id,
            fk_idCatSubArea: this.personal.fk_idCatSubArea,
          })
        }

        await this.sendNotification(this.prevTipoFuncionId, this.personal.fk_idCatTipoFuncion)

        // Refresca el listado de notificaciones para que se muestre en la tabla
        await this.fetchNotifications()

        this.SET_SNACKBAR_MESSAGE('La información del elemento ha sido actualizada correctamente.')
        this.$router.go(-1)
      }
    },

    async onSedeChange(sedeId) {
      this.personal.fk_idSubsede = null
      if (!sedeId) {
        this.subsedesFiltradas = []
        return
      }
      await this.loadSubsedesBySede(sedeId)
    },

    async loadSubsedesBySede(sedeId) {
      try {
        await this.fetchSubsedesBySede({ id: sedeId })
        this.subsedesFiltradas = this.subsedes.filter((s) => s.fk_idSede === sedeId)
      } catch (error) {
        console.error('Error al cargar subsedes:', error)
        this.subsedesFiltradas = []
      }
    },

    getSedeLabel(item) {
      if (!item) return ''
      return item.nombre || item.title || item.sede || ''
    },

    async sendNotification(prevTipoFuncionId, newTipoFuncionId) {
      const prevTipoFuncion = this.tipoFuncion.find((t) => t.id === prevTipoFuncionId)
      const newTipoFuncion = this.tipoFuncion.find((t) => t.id === newTipoFuncionId)

      if (
        prevTipoFuncion &&
        newTipoFuncion &&
        ((prevTipoFuncion.title === 'Funciones Administrativas' && newTipoFuncion.title === 'Funciones Operativas') ||
          (prevTipoFuncion.title === 'Funciones Operativas' && newTipoFuncion.title === 'Funciones Administrativas'))
      ) {
        const nombreElemento = this.getFullName(this.personal)
        const mensaje = `El elemento ${nombreElemento} cambió de tipo de puesto de ${prevTipoFuncion.title} a ${newTipoFuncion.title}.`

        const notification = new NotificationFactory(Notificacion).createNotification(
          NOTIFICATION_TYPES.CAMBIO_TIPO_PUESTO,
          {
            responsable: Number(localStorage.getItem('idPersonal')),
            afectado: this.personal.idPersonal,
            mensaje,
          }
        )

        await this.createNotification(notification)
      }
    },
  },
}
</script>

<style scoped>
/* Modern Card with Glass-morphism */
.ui-module-card {
  background: rgba(26, 38, 46, 0.6) !important;
  backdrop-filter: blur(10px) !important;
  -webkit-backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  border-radius: 20px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3) !important;
  transition: all 0.3s ease !important;
}

::v-deep .ui-module-card .v-card__title {
  padding: 20px 24px !important;
  background: rgba(0, 0, 0, 0.15) !important;
  border-bottom: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  color: #e0e0e0 !important;
}

::v-deep .ui-module-card .v-card__text {
  padding: 24px !important;
  background: transparent !important;
}

/* Labels personalizados */
.step-label {
  color: rgba(224, 224, 224, 0.7) !important;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 600 !important;
}

.step-title {
  color: var(--v-secondary-base) !important;
  font-size: 1.1rem !important;
  margin-top: 4px;
}

.back-link {
  color: var(--v-secondary-base) !important;
  cursor: pointer;
  font-size: 0.875rem;
  transition: all 0.3s ease;
}

.back-link:hover {
  color: var(--v-secondary-lighten1) !important;
  text-decoration: underline !important;
}

/* Radio Label */
.radio-label {
  color: rgba(224, 224, 224, 0.7) !important;
  margin-bottom: 8px;
}

/* Required Asterisk */
.required-asterisk {
  color: #fc5c65 !important;
  font-weight: bold !important;
}

/* Botones modernos */
::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative !important;
  overflow: hidden !important;
}

::v-deep .v-btn:hover:not(:disabled):not(.v-btn--text) {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6) !important;
}

::v-deep .v-btn.secondary:not(.v-btn--text) {
  background: linear-gradient(135deg, var(--v-secondary-base) 0%, var(--v-secondary-lighten1) 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 16px rgba(var(--v-secondary-base-rgb), 0.4) !important;
}

::v-deep .v-btn--text {
  background: transparent !important;
  color: #e0e0e0 !important;
}

::v-deep .v-btn--text:hover {
  background: rgba(var(--v-secondary-base-rgb), 0.1) !important;
}

::v-deep .v-btn .v-icon {
  transition: all 0.3s ease !important;
  color: inherit !important;
}

::v-deep .v-btn:hover .v-icon {
  transform: scale(1.1) !important;
}

/* Progress circular */
::v-deep .v-progress-circular {
  transition: all 0.3s ease;
}

::v-deep .v-progress-circular__overlay {
  stroke: var(--v-secondary-base) !important;
  filter: drop-shadow(0 4px 12px rgba(var(--v-secondary-base-rgb), 0.6));
}

/* Input fields */
::v-deep .v-text-field.v-text-field--filled > .v-input__control > .v-input__slot,
::v-deep .v-select.v-text-field--filled > .v-input__control > .v-input__slot,
::v-deep .v-autocomplete.v-text-field--filled > .v-input__control > .v-input__slot {
  background: rgba(0, 0, 0, 0.3) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
}

::v-deep .v-text-field.v-text-field--filled:hover > .v-input__control > .v-input__slot,
::v-deep .v-select.v-text-field--filled:hover > .v-input__control > .v-input__slot,
::v-deep .v-autocomplete.v-text-field--filled:hover > .v-input__control > .v-input__slot {
  border-color: rgba(var(--v-secondary-base-rgb), 0.4) !important;
  background: rgba(0, 0, 0, 0.4) !important;
}

::v-deep .v-input--is-focused.v-text-field--filled > .v-input__control > .v-input__slot {
  border-color: var(--v-secondary-base) !important;
  box-shadow: 0 0 0 2px rgba(var(--v-secondary-base-rgb), 0.15) !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

::v-deep .v-text-field--filled .v-text-field__slot input,
::v-deep .v-select--is-menu-active input {
  color: #e0e0e0 !important;
}

::v-deep .v-text-field--filled .v-label,
::v-deep .v-select .v-label,
::v-deep .v-autocomplete .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .v-input--is-focused .v-label {
  color: var(--v-secondary-base) !important;
}

::v-deep .v-select__selection,
::v-deep .v-select__selection-text {
  color: #e0e0e0 !important;
}

::v-deep .v-icon {
  color: rgba(var(--v-secondary-base-rgb), 0.7) !important;
}

::v-deep .v-input--is-focused .v-icon {
  color: var(--v-secondary-base) !important;
}

/* Radio buttons */
::v-deep .v-radio .v-label {
  color: rgba(224, 224, 224, 0.9) !important;
}

::v-deep .v-input--radio-group__input .v-input--selection-controls__input .v-icon {
  color: rgba(var(--v-secondary-base-rgb), 0.5) !important;
}

::v-deep .v-item--active .v-icon {
  color: var(--v-secondary-base) !important;
}

/* List Items (autocomplete) */
::v-deep .v-list {
  background: rgba(26, 38, 46, 0.95) !important;
  backdrop-filter: blur(10px);
  border-radius: 12px;
}

::v-deep .v-list-item {
  border-radius: 8px;
  margin: 4px 8px;
  transition: all 0.3s ease;
}

::v-deep .v-list-item:hover {
  background: rgba(var(--v-secondary-base-rgb), 0.15) !important;
}

::v-deep .v-list-item__title,
::v-deep .v-list-item__subtitle {
  color: #e0e0e0 !important;
}

/* Textos generales */
.text-caption,
.text-subtitle-1,
.text-subtitle-2 {
  color: #e0e0e0 !important;
}

.font-weight-bold {
  font-weight: 700 !important;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(var(--v-secondary-base-rgb), 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(var(--v-secondary-base-rgb), 0.6);
}
</style>
